export default "__VITE_ASSET__B3T80yk0__"